import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker", "input"]

  connect() {
    this.syncPickerToInput()
  }

  syncInputToPicker() {
    const value = this.inputTarget.value
    if (this.isValidHex(value)) {
      this.pickerTarget.value = this.normalizeHex(value)
    }
  }

  syncPickerToInput() {
    this.inputTarget.value = this.pickerTarget.value.toUpperCase()
  }

  isValidHex(color) {
    return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(color)
  }

  normalizeHex(color) {
    if (color.length === 4) {
      return '#' + color[1] + color[1] + color[2] + color[2] + color[3] + color[3]
    }
    return color.toUpperCase()
  }
}
